<ng-container *ngFor="let item of items">
    <div class="row">
        <div class="col-12">
            <div [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
                [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'HEADING'" [innerHTML]="item?.content">
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [style.padding-top.px]="item?.padding" [style.padding-bottom.px]="item?.padding"
            *ngIf="item.type == 'PARAGRAPH'">
            <div class="pb-editor" [innerHTML]="item?.content | safeHtml"></div>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'BUTTON'">
            <a href="{{ item?.content?.link }}" target="_blank">
                <button type="button" class="px-10 py-4 btn btn-primary btn-lg rounded-pill font-size-16 font-weight-bold">
                    {{ item?.content?.text }}
                </button>
            </a>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'LINK'">
            <ng-container *ngIf="item?.content?.link?.includes('http') || item?.content?.link?.includes('mailto')">
                <a href="{{ item?.content?.link }}" target="_blank">
                    <button type="button" class="px-10 py-4 btn btn-outline-primary btn-lg rounded-pill font-size-16 font-weight-bold">
                        {{ item?.content?.text }}
                    </button>
                </a>
            </ng-container>

            <ng-container *ngIf="!item?.content?.link?.includes('http') && !item?.content?.link?.includes('mailto')">
                <a routerLink="{{ item?.content?.link }}">
                    <button type="button" class="px-10 py-4 btn btn-outline-primary btn-lg rounded-pill font-size-16 font-weight-bold">
                        {{ item?.content?.text }}
                    </button>
                </a>
            </ng-container>
        </div>
    </div>

    <div class="row">
        <div class="col-12 d-flex" [class.justify-content-start]="item?.alignment == 'text-left'"
            [class.justify-content-center]="item?.alignment == 'text-center'"
            [class.justify-content-end]="item?.alignment == 'text-right'" [ngClass]="item?.alignment"
            [style.padding-top.px]="item?.padding" [style.padding-bottom.px]="item?.padding"
            *ngIf="item?.type == 'IMAGE'">
            <!-- Open URL on click -->
            <a *ngIf="item?.extra_data?.url" href="{{item?.extra_data?.url}}" target="_blank">
                <img loading="lazy" [src]="item?.content" [alt]="item?.extra_data?.alt" class="img-fluid" />
            </a>
            <!-- Open file on click -->
            <a *ngIf="!item?.extra_data?.url && item?.extra_data?.file" href="{{item?.extra_data?.file}}"
                target="_blank">
                <img loading="lazy" [src]="item?.content" [alt]="item?.extra_data?.alt" class="img-fluid" />
            </a>
            <!-- Just an image -->
            <img loading="lazy" *ngIf="!item?.extra_data?.url && !item?.extra_data?.file " [src]="item?.content" [alt]="item?.extra_data?.alt" class="img-fluid" />
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'ICON'">
            <div class="inline-block">
                <img loading="lazy" [src]="item?.content" class="img-fluid" />
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'VIDEO'">
            <div class="pb-video-iframe" [innerHTML]="item?.content | safeHtml">
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'BULLET_LIST'">
            <ul class="font-size-16">
                <li *ngFor="let inx of item?.content">{{ inx }}</li>
            </ul>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'NUM_LIST'">
            <ol class="font-size-16">
                <li *ngFor="let inx of item?.content">{{ inx }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [ngClass]="item?.alignment" [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" *ngIf="item?.type == 'BLOCKQUOTE'">
            <blockquote class="separate-blockquote">
                {{ item?.content }}
            </blockquote>
        </div>
    </div>
</ng-container>